export default __webpack_public_path__ + "static/media/member_since.56ca3389.svg";